import App from '../../class/App';

new App();
